"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMenuByRouter = exports.getHomeRoute = exports.getCookies = exports.getBreadCrumbList = exports.getArrayFromFile = exports.findNodeUpperByClasses = exports.findNodeUpper = exports.findNodeDownward = exports.doCustomTimes = exports.canTurnTo = exports.R = void 0;
exports.getMenuopen = getMenuopen;
exports.showTitle = exports.showByAccess = exports.setTitle = exports.setTagNavListInLocalstorage = exports.setCookies = exports.scrollTop = exports.routeHasExist = exports.routeEqual = exports.removeCookies = exports.localSave = exports.localRead = exports.hasChild = exports.getTagNavListFromLocalstorage = exports.getTableDataFromArray = exports.getRouteTitleHandled = exports.getParams = exports.getNextRoute = exports.getNewTagList = void 0;
exports.wss = wss;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _tools = require("@/libs/tools");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// cookie保存的天数
var title = '';

// 设置setCookies；
// setToken
var setCookies = exports.setCookies = function setCookies(key, val, cookieExpires) {
  _jsCookie.default.set(key, val, {
    expires: cookieExpires || 1
  });
};
// 获取getCookies；
// getToken
var getCookies = exports.getCookies = function getCookies(key) {
  return _jsCookie.default.get(key);
};

/**
 * 从cookie中移除指定的键值对
 * @param {string} key - 要移除的键名
 * @returns {boolean} - 移除成功返回true，否则返回false
 */
var removeCookies = exports.removeCookies = function removeCookies(key) {
  return _jsCookie.default.remove(key);
};

/**
 * 判断一个菜单项是否有子菜单
 * @param {object} item - 菜单项对象
 * @returns {boolean} - 有子菜单返回true，否则返回false
 */
var hasChild = exports.hasChild = function hasChild(item) {
  return item.children && item.children.length !== 0;
};

/**
 * 判断当前用户是否有权限访问该菜单项
 * @param {object} item - 菜单项对象
 * @param {array} access - 用户拥有的权限列表
 * @returns {boolean} - 有权限返回true，否则返回false
 */
var showThisMenuEle = function showThisMenuEle(item, access) {
  // 判断菜单项是否设置了权限
  if (item.meta && item.meta.access && item.meta.access.length) {
    // 判断用户是否拥有该菜单项的权限
    if ((0, _tools.hasOneOf)(item.meta.access, access)) return true;else return false;
  } else return true;
};

/**
 * @param {Array} list 通过路由列表得到菜单列表
 * @returns {Array}
 */
var _getMenuByRouter = exports.getMenuByRouter = function getMenuByRouter(list, access) {
  var res = [];
  (0, _tools.forEach)(list, function (item) {
    if (!item.meta || item.meta && !item.meta.hideInMenu) {
      var obj = {
        icon: item.meta && item.meta.icon || '',
        name: item.name,
        meta: item.meta
      };
      if ((hasChild(item) || item.meta && item.meta.showAlways) && showThisMenuEle(item, access)) {
        obj.children = _getMenuByRouter(item.children, access);
      }
      if (item.meta && item.meta.href) obj.href = item.meta.href;
      if (showThisMenuEle(item, access)) res.push(obj);
    }
  });
  return res;
};

/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
var getBreadCrumbList = exports.getBreadCrumbList = function getBreadCrumbList(route, homeRoute) {
  var homeItem = _objectSpread({}, homeRoute);
  var routeMetched = route.matched;
  if (routeMetched.some(function (item) {
    return item.name === homeRoute.name;
  })) return [homeItem];
  var res = routeMetched.filter(function (item) {
    return item.meta === undefined || !item.meta.hideInBread;
  }).map(function (item) {
    var meta = _objectSpread({}, item.meta);
    if (meta.title && typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true;
      meta.title = meta.title(route);
    }
    var obj = {
      icon: item.meta && item.meta.icon || '',
      name: item.name,
      meta: meta
    };
    return obj;
  });
  res = res.filter(function (item) {
    return !item.meta.hideInMenu;
  });
  return [_objectSpread(_objectSpread({}, homeItem), {}, {
    to: homeRoute.path
  })].concat(_toConsumableArray(res));
};

/**
 * 获取处理后的路由标题
 * @param {Object} route - 路由对象
 * @returns {Object} - 处理后的路由对象
 */
var getRouteTitleHandled = exports.getRouteTitleHandled = function getRouteTitleHandled(route) {
  // 克隆路由对象和元数据对象
  var router = _objectSpread({}, route);
  var meta = _objectSpread({}, route.meta);
  var title = '';
  // 判断元数据对象中是否存在标题属性
  if (meta.title) {
    // 如果标题属性是函数类型，则调用该函数并将结果赋值给title
    if (typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true;
      title = meta.title(router);
    } else title = meta.title;
  }
  // 将处理后的标题赋值给元数据对象中的title属性
  meta.title = title;
  // 将处理后的元数据对象赋值给路由对象中的meta属性
  router.meta = meta;
  // 返回处理后的路由对象
  return router;
};

/**
 * 显示路由标题
 * @param {Object} item - 当前路由对象
 * @param {Object} vm - Vue实例对象
 * @returns {string|undefined} - 返回路由标题字符串或undefined
 */
var showTitle = exports.showTitle = function showTitle(item, vm) {
  // 从路由元数据中获取标题和标题是否为函数的标志
  var _item$meta = item.meta,
    title = _item$meta.title,
    __titleIsFunction__ = _item$meta.__titleIsFunction__;
  // 如果没有标题则直接返回
  if (!title) return;
  // 如果标题不存在，则从路由对象中获取名称作为标题
  title = item.meta && item.meta.title || item.name;
  // 返回标题字符串
  return title;
};

/**
 * @description 本地存储和获取标签导航列表
 */
var setTagNavListInLocalstorage = exports.setTagNavListInLocalstorage = function setTagNavListInLocalstorage(list) {
  localStorage.setItem('tagNaveListJavaMer', JSON.stringify(list));
};
/**
 * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
 */
var getTagNavListFromLocalstorage = exports.getTagNavListFromLocalstorage = function getTagNavListFromLocalstorage() {
  var list = localStorage.getItem('tagNaveListJavaMer');
  return list ? JSON.parse(list) : [];
};

/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
var _getHomeRoute = exports.getHomeRoute = function getHomeRoute(routers) {
  var homeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'home';
  var i = -1;
  var len = routers.length;
  var homeRoute = {};
  while (++i < len) {
    var item = routers[i];
    if (item.children && item.children.length) {
      var res = _getHomeRoute(item.children, homeName);
      if (res.name) return res;
    } else {
      if (item.name === homeName) homeRoute = item;
    }
  }
  return homeRoute;
};

/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由原信息对象
 * @description 如果该newRoute已经存在则不再添加
 */
var getNewTagList = exports.getNewTagList = function getNewTagList(list, newRoute) {
  var name = newRoute.name,
    path = newRoute.path,
    meta = newRoute.meta;
  var newList = _toConsumableArray(list);
  if (newList.findIndex(function (item) {
    return item.path === path;
  }) >= 0) return newList;else newList.push({
    name: name,
    path: path,
    meta: meta
  });
  return newList;
};

/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
 * @param {*} route 路由列表
 */
var hasAccess = function hasAccess(access, route) {
  if (route.meta && route.meta.access) return (0, _tools.hasOneOf)(access, route.meta.access);else return true;
};

/**
 * 权鉴
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */
var canTurnTo = exports.canTurnTo = function canTurnTo(name, access, routes) {
  var _routePermissionJudge = function routePermissionJudge(list) {
    return list.some(function (item) {
      if (item.children && item.children.length) {
        return _routePermissionJudge(item.children);
      } else if (item.name === name) {
        return hasAccess(access, item);
      }
    });
  };
  return _routePermissionJudge(routes);
};

/**
 * @param {String} url
 * @description 从URL中解析参数
 */
var getParams = exports.getParams = function getParams(url) {
  var keyValueArr = url.split('?')[1].split('&');
  var paramObj = {};
  keyValueArr.forEach(function (item) {
    var keyValue = item.split('=');
    paramObj[keyValue[0]] = keyValue[1];
  });
  return paramObj;
};

/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */
var getNextRoute = exports.getNextRoute = function getNextRoute(list, route) {
  var res = {};
  if (list.length === 2) {
    res = _getHomeRoute(list);
  } else {
    var index = list.findIndex(function (item) {
      return routeEqual(item, route);
    });
    if (index === list.length - 1) res = list[list.length - 2];else res = list[index + 1];
  }
  return res;
};

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
var doCustomTimes = exports.doCustomTimes = function doCustomTimes(times, callback) {
  var i = -1;
  while (++i < times) {
    callback(i);
  }
};

/**
 * @param {Object} file 从上传组件得到的文件对象
 * @returns {Promise} resolve参数是解析后的二维数组
 * @description 从Csv文件中解析出表格，解析成二维数组
 */
var getArrayFromFile = exports.getArrayFromFile = function getArrayFromFile(file) {
  var nameSplit = file.name.split('.');
  var format = nameSplit[nameSplit.length - 1];
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsText(file); // 以文本格式读取
    var arr = [];
    reader.onload = function (evt) {
      var data = evt.target.result; // 读到的数据
      var pasteData = data.trim();
      arr = pasteData.split(/[\n\u0085\u2028\u2029]|\r\n?/g).map(function (row) {
        return row.split('\t');
      }).map(function (item) {
        return item[0].split(',');
      });
      if (format === 'csv') resolve(arr);else reject(new Error('[Format Error]:你上传的不是Csv文件'));
    };
  });
};

/**
 * @param {Array} array 表格数据二维数组
 * @returns {Object} { columns, tableData }
 * @description 从二维数组中获取表头和表格数据，将第一行作为表头，用于在表格中展示数据
 */
var getTableDataFromArray = exports.getTableDataFromArray = function getTableDataFromArray(array) {
  var columns = [];
  var tableData = [];
  if (array.length > 1) {
    var titles = array.shift();
    columns = titles.map(function (item) {
      return {
        title: item,
        key: item
      };
    });
    tableData = array.map(function (item) {
      var res = {};
      item.forEach(function (col, i) {
        res[titles[i]] = col;
      });
      return res;
    });
  }
  return {
    columns: columns,
    tableData: tableData
  };
};

/**
 * 查找元素的上一个指定标签名的父节点
 * @param {Element} ele - 要查找的元素
 * @param {string} tag - 指定的标签名
 * @returns {Element|undefined} - 返回找到的父节点或 undefined
 */
var _findNodeUpper = exports.findNodeUpper = function findNodeUpper(ele, tag) {
  // 如果元素存在父节点
  if (ele.parentNode) {
    // 如果父节点的标签名与指定标签名相同
    if (ele.parentNode.tagName === tag.toUpperCase()) {
      // 返回父节点
      return ele.parentNode;
    } else {
      // 递归查找父节点的父节点
      return _findNodeUpper(ele.parentNode, tag);
    }
  }
};

/**
 * 根据类名查找元素的上级节点
 * @param {HTMLElement} ele - 目标元素
 * @param {string[]} classes - 目标类名数组
 * @returns {HTMLElement|null} - 返回符合条件的上级节点，若不存在则返回 null
 */
var _findNodeUpperByClasses = exports.findNodeUpperByClasses = function findNodeUpperByClasses(ele, classes) {
  // 获取目标元素的父节点
  var parentNode = ele.parentNode;
  if (parentNode) {
    // 获取父节点的类名列表
    var classList = parentNode.classList;
    if (
    // 判断父节点是否存在目标类名
    classList && classes.every(function (className) {
      return classList.contains(className);
    })) {
      // 返回符合条件的父节点
      return parentNode;
    } else {
      // 递归查找父节点的父节点
      return _findNodeUpperByClasses(parentNode, classes);
    }
  }
};

/**
 * 从当前元素向下查找指定标签名的子元素
 * @param {HTMLElement} ele - 当前元素
 * @param {string} tag - 目标标签名
 * @returns {HTMLElement|undefined} - 返回找到的子元素或 undefined
 */
var _findNodeDownward = exports.findNodeDownward = function findNodeDownward(ele, tag) {
  // 将目标标签名转换为大写字母
  var tagName = tag.toUpperCase();
  // 如果当前元素存在子节点
  if (ele.childNodes.length) {
    var i = -1;
    var len = ele.childNodes.length;
    // 遍历子节点
    while (++i < len) {
      var child = ele.childNodes[i];
      // 如果找到目标标签名的子元素，则返回该子元素
      if (child.tagName === tagName) return child;
      // 否则递归查找子元素的子元素
      else return _findNodeDownward(child, tag);
    }
  }
};

/**
 * 根据用户权限判断是否可以查看某个页面或操作
 * @param {Array} access - 当前用户的权限数组
 * @param {Array} canViewAccess - 可以查看的权限数组
 * @returns {Boolean} - 是否可以查看
 */
var showByAccess = exports.showByAccess = function showByAccess(access, canViewAccess) {
  // 调用 hasOneOf 函数判断当前用户是否有查看权限
  return (0, _tools.hasOneOf)(canViewAccess, access);
};

/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */
var routeEqual = exports.routeEqual = function routeEqual(route1, route2) {
  var params1 = route1.params || {};
  var params2 = route2.params || {};
  var query1 = route1.query || {};
  var query2 = route2.query || {};
  return route1.name === route2.name && (0, _tools.objEqual)(params1, params2) && (0, _tools.objEqual)(query1, query2);
};

/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */
var routeHasExist = exports.routeHasExist = function routeHasExist(tagNavList, routeItem) {
  var len = tagNavList.length;
  var res = false;
  doCustomTimes(len, function (index) {
    if (routeEqual(tagNavList[index], routeItem)) res = true;
  });
  return res;
};
var localSave = exports.localSave = function localSave(key, value) {
  localStorage.setItem(key, value);
};
var localRead = exports.localRead = function localRead(key) {
  return localStorage.getItem(key) || '';
};

// scrollTop animation
var scrollTop = exports.scrollTop = function scrollTop(el) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var to = arguments.length > 2 ? arguments[2] : undefined;
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  var endCallback = arguments.length > 4 ? arguments[4] : undefined;
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    };
  }
  var difference = Math.abs(from - to);
  var step = Math.ceil(difference / duration * 50);
  var _scroll = function scroll(start, end, step) {
    if (start === end) {
      endCallback && endCallback();
      return;
    }
    var d = start + step > end ? end : start + step;
    if (start > end) {
      d = start - step < end ? end : start - step;
    }
    if (el === window) {
      window.scrollTo(d, d);
    } else {
      el.scrollTop = d;
    }
    window.requestAnimationFrame(function () {
      return _scroll(d, end, step);
    });
  };
  _scroll(from, to, step);
};

/**
 * @description 根据当前跳转的路由设置显示在浏览器标签的title
 * @param {Object} routeItem 路由对象
 * @param {Object} vm Vue实例
 */
var setTitle = exports.setTitle = function setTitle(routeItem, vm) {
  var winTitle = localStorage.getItem('ADMIN_TITLE') || title;
  var handledRoute = getRouteTitleHandled(routeItem);
  var pageTitle = showTitle(handledRoute, vm);
  var resTitle = pageTitle ? "".concat(winTitle, " - ").concat(pageTitle) : winTitle;
  window.document.title = resTitle;
};
var _R = exports.R = function R(menuList, newOpenMenus) {
  menuList.forEach(function (item) {
    var newMenu = {};
    for (var i in item) {
      if (i !== 'children') newMenu[i] = (0, _lodash.cloneDeep)(item[i]);
    }
    newOpenMenus.push(newMenu);
    item.children && _R(item.children, newOpenMenus);
  });
  return newOpenMenus;
};

/**
 * 获取当前菜单打开状态
 * @param {Object} to - 当前路由对象
 * @param {Array} menuList - 菜单列表
 * @returns {Array} - 当前菜单打开状态数组
 */
function getMenuopen(to, menuList) {
  // 初始化所有菜单数组
  var allMenus = [];
  // 遍历菜单列表
  menuList.forEach(function (menu) {
    // 转换菜单结构
    var menus = transMenu(menu, []);
    // 添加当前菜单到所有菜单数组
    allMenus.push({
      path: menu.path,
      openNames: []
    });
    // 添加子菜单到所有菜单数组
    menus.forEach(function (item) {
      return allMenus.push(item);
    });
  });
  // 查找当前菜单
  var currentMenu = allMenus.find(function (item) {
    return item.path === to.path;
  });
  // 返回当前菜单打开状态数组
  return currentMenu ? currentMenu.openNames : [];
}

/**
 * 将菜单转换为可展开的形式
 * @param {Object} menu - 菜单对象
 * @param {Array} openNames - 已打开的菜单路径数组
 * @returns {Array} - 可展开的菜单数组
 */
function transMenu(menu, openNames) {
  // 判断当前菜单是否有子菜单
  if (menu.children && menu.children.length) {
    // 将当前菜单路径添加到已打开的菜单路径数组中
    var itemOpenNames = openNames.concat([menu.path]);
    // 递归处理子菜单
    return menu.children.reduce(function (all, item) {
      // 将当前子菜单的路径和已打开的菜单路径数组添加到结果数组中
      all.push({
        path: item.path,
        openNames: itemOpenNames
      });
      // 递归处理子菜单的子菜单
      var foundChildren = transMenu(item, itemOpenNames);
      // 将子菜单的子菜单添加到结果数组中
      return all.concat(foundChildren);
    }, []);
  } else {
    // 如果当前菜单没有子菜单，则直接将当前菜单添加到结果数组中
    return [menu].map(function (item) {
      return {
        path: item.path,
        openNames: openNames
      };
    });
  }
}
function wss(wsSocketUrl) {
  var ishttps = document.location.protocol == 'https:';
  if (ishttps) {
    return wsSocketUrl.replace('ws:', 'wss:');
  } else {
    return wsSocketUrl.replace('wss:', 'ws:');
  }
}